"use strict";

require("./..\\..\\..\\..\\bower_components\\iCheck\\icheck.min.js");

module.exports = function () {
	$('.i-checks').iCheck({
		checkboxClass: 'icheckbox_square-green',
		radioClass: 'iradio_square-green'
	});
};